import { Button, Checkbox } from 'antd';
import React, { PureComponent } from 'react';
import { SettingsContentPanel } from '../../../common/SettingsContentPanel';
import { Flex } from '../../../common/Flex';
import { SettingFilled } from '@ant-design/icons';
import { ClosablePopover } from '../../../common/ClosablePopover';
import {
    FilterLogic,
    FLIGHT_MEASURE_FILTER_CONFIG_CLAZZ_VALUE,
    FlightMeasureFilterConfig,
} from '../../../../model/SOL49';
import { FilterSettings } from '../../../../model/client/SOL49';

export const DEFAULT_MEASURE_FLIGHTS_SETTINGS: MeasureFlightsFilterSettings = {
    filterLogic: FilterLogic.UNION,
    config: {
        clazz: FLIGHT_MEASURE_FILTER_CONFIG_CLAZZ_VALUE,
        mprOnly: false,
    },
};

export interface MeasureFlightsFilterSettings extends FilterSettings<FlightMeasureFilterConfig> {}

export class MeasureFlightsFilterSettingsContent extends SettingsContentPanel<MeasureFlightsFilterSettings> {
    handleMprOnlyChange = changeEvent => {
        const config = { ...this.state.config, mprOnly: changeEvent.target.checked };
        this.setState({ config: config });
    };
    render() {
        return (
            <Flex direction="vertical" className="settings-content" style={{ width: '30em', padding: '1em' }}>
                <Flex className="label">
                    <Checkbox
                        checked={this.state.filterLogic === FilterLogic.INTERSECT}
                        onChange={value =>
                            this.setState({
                                filterLogic: value.target.checked ? FilterLogic.INTERSECT : FilterLogic.UNION,
                            })
                        }>
                        Show only common flights concerned by selected measures
                    </Checkbox>
                </Flex>
                <Flex className="label">
                    <Checkbox checked={this.state.config?.mprOnly === true} onChange={this.handleMprOnlyChange}>
                        Show only flights being most penalised by selected measures
                    </Checkbox>
                </Flex>
                <Flex style={{ justifyContent: 'space-around' }}>
                    <Button onClick={this.handleApply}>Apply</Button>
                    <Button onClick={this.handleClose}>Close</Button>
                </Flex>
            </Flex>
        );
    }
}

interface MeasureFlightsFilterSettingsButtonProps {
    settings: MeasureFlightsFilterSettings;
    onSettingsChange: (settings: MeasureFlightsFilterSettings) => void;
}

export class MeasureFlightsFilterSettingsButton extends PureComponent<MeasureFlightsFilterSettingsButtonProps> {
    private settingsPopoverRef = React.createRef<ClosablePopover>();
    handleSettingsChange = (settings: MeasureFlightsFilterSettings) => {
        this.props.onSettingsChange?.(settings);
        this.settingsPopoverRef.current.hide();
    };
    getTvFlightsFilterSettingsContent = () => {
        return (
            <MeasureFlightsFilterSettingsContent
                settings={this.props.settings}
                onChange={this.handleSettingsChange}
                onClose={() => {
                    this.settingsPopoverRef.current.hide();
                }}
            />
        );
    };
    render() {
        return (
            <ClosablePopover
                key="settings-action"
                ref={this.settingsPopoverRef}
                trigger="click"
                placement="bottom"
                title={<div style={{ fontWeight: 'bold' }}>FILTER'S SETTINGS</div>}
                content={this.getTvFlightsFilterSettingsContent()}>
                <Button
                    onClick={() => this.settingsPopoverRef.current.show()}
                    style={{ backgroundColor: 'transparent', borderColor: 'transparent' }}>
                    <SettingFilled />
                </Button>
            </ClosablePopover>
        );
    }
}
